function getHostInfo() {
  if (typeof window === 'undefined') return
  const hostname = window.location.hostname
  const env = hostname?.split('.')[0].split('-')[0]
  switch (env) {
    case 'localhost':
    case 'test':
      return {
        user: 'https://test-user-1.17track.net'
      }
    case 'uat':
      return {
        user: 'https://uat-user.17track.net'
      }
    case 'www':
      return {
        user: 'https://user.17track.net'
      }
    default:
      return {
        user: 'https://user.17track.net'
      }
  }
}

export default getHostInfo
